import search from '../search'

export const submitSearch = ({
  searchTerm,
  index,
  queryData,
  filters,
  searchLimit,
  setItems,
  setSearchCount,
  setLoadMoreCount,
  setHits,
  searchRadius,
  hasGoogleMapsConsent,
  locale
}) => {
  const queryConfig = {
    searchTerm,
    index,
    queryData,
    filters,
    searchLimit,
    searchRadius,
    hasGoogleMapsConsent,
    locale
  }
  search(queryConfig)
    .then(res => {
      // aggrResult is currently only needed for the jobtype overview page
      const aggregations = res?.response?.data?.aggregations
      const aggrResultLength =
        aggregations?.value_aggregation?.buckets?.buckets.length

      setHits(res.hits)
      const responseCount = res?.response?.data?.hits?.total?.value
      setLoadMoreCount(aggrResultLength || responseCount)
      setSearchCount(aggrResultLength || responseCount)
      setItems(res?.response?.data?.aggregations || res?.result || [])
    })
    .catch(error => {
      setHits(0)
      setItems([])
      console.error(
        'Cannot reach search on:',
        JSON.stringify(queryConfig),
        error
      )
    })
}
